const makeSelectFilterSort = (_a, _b) => _a.children.toLowerCase().localeCompare(_b.children.toLowerCase());


export default makeSelectFilterSort;
